import _startCase from 'lodash/startCase';
import _toLower from 'lodash/toLower';
import _upperFirst from 'lodash/upperFirst';
import { useTranslation } from 'react-i18next';
import { SsoIntegration, SsoIntegrationProviderTypeEnum } from 'graphql-common';
import getSsoProviderTypeChipType from '@lib/utils/getSsoProviderTypeChipType';
import Chip from '@lib/components/Chip/Chip';

type Props = {
  data: SsoIntegration;
};

export default function SsoProviderTypeChip(props: Props) {
  const { data } = props;
  const { providerType } = data;
  const { t } = useTranslation();
  const options = [
    { value: SsoIntegrationProviderTypeEnum.Saml, title: t('saml') },
  ];
  let label: string | undefined = '-';
  if (providerType) {
    label = options.find(({ value }) => value === providerType)?.title;
  }
  if (label === undefined)
    label = _upperFirst(_toLower(_startCase(providerType)));
  const type = getSsoProviderTypeChipType(providerType);

  return <Chip type={type} label={label} />;
}
